/**************************************************
 * Nombre:       Dialogo_Movimiento
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import logo from '../../Recursos/logo_redondo.svg'
import {guardarDoc} from "../../Servicios/BD/guardarDoc";
import {Check, Delete} from "@mui/icons-material";
import {borrarDoc} from "../../Servicios/BD/borrarDoc";
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import {useContext} from "react";
import {usuarioContext} from "../../App";
import Formulario_Movimiento from "../Formularios/Formulario_Movimiento";
import {obtenerConsecutivo} from "../../Servicios/BD/Consecutivos/obtenerConsecutivo";
import {aumentarConsecutivo} from "../../Servicios/BD/Consecutivos/aumentarConsecutivo";

const Dialogo_Movimiento = ({datos, cerrar, realizado}) => {
    const cData = useContext(usuarioContext)
    const {props, obtenerEntidad} = useFormulario({valoresDefecto: datos})
    const {Avisos, Cargador, nuevoAviso, terminar, iniciarCarga} = useCargador({
        logoRedondo: logo,
        funcionUno: cerrar,
        funcionDos: realizado
    })


    const subirDatos = async () => {

        let entidad = await obtenerEntidad()
        iniciarCarga('Guardando datos')

        if (!entidad.consecutivo) {
            let doxNun = await obtenerConsecutivo({col: 'consecutivos', id: 'movimientos'})
            entidad.consecutivo = doxNun.data
            await aumentarConsecutivo({col: 'consecutivos', id: 'movimientos', actual: doxNun.data})
        }


        let dox = await guardarDoc('movimientos', entidad)
        if (dox.res) {

            terminar({aviso: 'Datos Actualizados'})
        } else {
            terminar({aviso: 'Ups algo inesperado paso, intentalo nuevamente', variante: 'error'})
        }


    }

    const borrar = async () => {
        await borrarDoc('movimientos', datos.id)
        terminar({aviso: 'Movimiento borrado'})
    }
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 1}}
        >

            <Avisos/>

            <Cargador/>

            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Formulario_Movimiento props={props}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: 3}}>
                <Button
                    onClick={() => subirDatos()}
                    startIcon={<Check/>}
                >Actualizar Datos</Button>
            </Grid>

            {datos && datos.id &&
                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Button
                        onClick={() => borrar()}
                        color={'success'} startIcon={<Delete/>} variant={'text'}>
                        Borrar
                    </Button>
                </Grid>
            }


        </Grid>
    )

}
export default Dialogo_Movimiento